@if (!error) {
  <div class="flex-column margin-b-10">
    <div class="flex-1"></div>
    @for (form of customerResponse; track form) {
      <mat-accordion class="headers-align flex-3" multi>
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{form.form.name}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (question of form.questionAnswers; track question) {
            <div>
              <div style="font-weight: bold">
                {{question.question.label}}
              </div>
              @for (answer of question.answers; track answer) {
                <div>
                  {{question.question.type == 'bool' ? answer.value == 'true' ? 'Yes' : 'No' : answer.value == '' ? '--' : answer.value}}
                </div>
              }
              <hr>
              </div>
            }
          </mat-expansion-panel>
        </mat-accordion>
      }
    </div>
  } @else {
    <div>
      <h1 class="errorMessage">{{errorMessage}}</h1>
    </div>
  }

